import { computed, type Component } from "vue";
import { useRoute } from "vue-router";
import DefaultLayout from "@/layouts/default.vue";
import RoomsLayout from "@/layouts/rooms.vue";
import LoginLayout from "@/layouts/login.vue";
import ErrorLayout from "@/layouts/error.vue";
import PublicLayout from "@/layouts/public.vue";
import AdminLayout from "@/layouts/admin.vue";
import EmptyLayout from "@/layouts/empty.vue";

export interface LayoutConfig {
  name: string;
  requiresAuth?: boolean;
  title?: string;
}

const DEFAULT_META = {
  name: "default",
  requiresAuth: true,
};

const layoutComponents: Record<string, Component> = {
  default: DefaultLayout,
  rooms: RoomsLayout,
  login: LoginLayout,
  error: ErrorLayout,
  public: PublicLayout,
  admin: AdminLayout as Component,
  empty: EmptyLayout,
};

export function useLayout() {
  const route = useRoute();

  const layout = computed((): LayoutConfig => {
    const pageMeta = route.meta || {};

    return {
      ...DEFAULT_META,
      ...pageMeta,
      name:
        (pageMeta.layout === false ? "empty" : (pageMeta.layout as string)) || DEFAULT_META.name,
    };
  });

  const layoutComponent = computed(() => {
    const layoutName = layout.value.name;
    return layoutComponents[layoutName] || layoutComponents.default;
  });

  return {
    layout,
    layoutComponent,
  };
}
